import React, { Component } from 'react'
import styled from 'styled-components'
import { Icon } from './Icon'
const Container = styled.div`
  position: relative;
`
const Wrapper = styled.input`
  width: ${props => (props.width ? props.width : '286px')};
  height: ${props => (props.height ? props.height : 48)}px;
  line-height: 1.2;
  letter-spacing: 0.1px;
  color: #000;
  border-radius: 4px 0 0 4px;
  outline: none;
  border: none;
  padding: 0 0 0 40px;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0.1px;
  :hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
    & + div > svg path {
      fill: ${props => (props.changeColor ? props.changeColor : '#333333')};
    }
    & + div > svg circle {
      fill: ${props => (props.changeColor ? props.changeColor : '#333333')};
    }
  }
  :focus {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
    & + div > svg path {
      fill: ${props => (props.changeColor ? props.changeColor : '#333333')};
    }
    & + div > svg circle {
      fill: ${props => (props.changeColor ? props.changeColor : '#333333')};
    }
  }
  @media (max-width: 768px) {
    height: 38px;
    border-radius: 4px;
  }

  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #666666;
    opacity: 1; /* Firefox */
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #666666;
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #666666;
  }
`
const Image = styled.div`
  z-index: 0;
  position: absolute;
  left: 10px;
  top: 14px;
  @media (max-width: 768px) {
    top: 8px !important;
  }
`
class Input extends Component {
  render() {
    const { icon, changeColor, ...props } = this.props
    return (
      <Container>
        <Wrapper changeColor={changeColor} {...props} />
        <Image>
          <Icon icon={icon} />
        </Image>
      </Container>
    )
  }
}
export { Input }



// WEBPACK FOOTER //
// ./src/components/Input.js